import {
  BarsOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  LockFilled,
  PicLeftOutlined,
} from '@ant-design/icons';
import { Button, Popover, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';

type Column = typeof defaultSubmittedTicketableColumns[0];

const SubmitTicketColumns = (props: {
  columns: Column[];
  setColumns: (payload: Column[]) => void;
}) => {
  const [columns, setColumns] = useState<Column[]>([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      setColumns(props.columns);
    }
  }, [visible, props.columns]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Popover
      title={null}
      visible={visible}
      onVisibleChange={vis => setVisible(vis)}
      trigger={'click'}
      placement="rightTop"
      content={
        <Wrapper>
          <DragDropContext
            onDragEnd={(result, provided) => {
              if (!result.destination) {
                // dropped outside oof the box
                return;
              }

              const sourceIdx = result.source.index;
              const targetIdx = result.destination.index;
              const newColumns = [...columns];
              const [moved] = newColumns.splice(sourceIdx, 1);
              newColumns.splice(targetIdx, 0, moved);
              setColumns(newColumns);
            }}
          >
            <Droppable droppableId="submitted-ticket-list-column-setting">
              {(provided, snapshot) => (
                <div
                  className="column-container"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{ width: 200 }}
                  // style={getListStyle(snapshot.isDraggingOver)}
                >
                  <div className={'column-li'}>
                    <LockFilled /> Ticket Number
                  </div>
                  {columns.map((item, index) => (
                    <Draggable
                      key={item.key}
                      draggableId={`${item.key}-${index}`}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          className={
                            'column-li' +
                            (snapshot.isDragging ? ' dragging' : '')
                          }
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          // style={getItemStyle(
                          //   snapshot.isDragging,
                          //   provided.draggableProps.style
                          // )}
                        >
                          <BarsOutlined /> {item.label}{' '}
                          <Tooltip
                            title={item.active ? 'Hide Column' : 'Show Column'}
                          >
                            {item.active ? (
                              <EyeOutlined
                                onClick={() =>
                                  setColumns(cols =>
                                    cols.map(c => {
                                      if (c.key === item.key) {
                                        return { ...c, active: false };
                                      }

                                      return c;
                                    })
                                  )
                                }
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() =>
                                  setColumns(cols =>
                                    cols.map(c => {
                                      if (c.key === item.key) {
                                        return { ...c, active: true };
                                      }

                                      return c;
                                    })
                                  )
                                }
                              />
                            )}
                          </Tooltip>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="btn-container">
            <Button
              size="small"
              onClick={() => setColumns(defaultSubmittedTicketableColumns)}
            >
              Reset
            </Button>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setVisible(false);
                props.setColumns(columns);
              }}
            >
              Apply
            </Button>
          </div>
        </Wrapper>
      }
    >
      <Button size="small" icon={<PicLeftOutlined />}>
        Sort Column
      </Button>
    </Popover>
  );
};

const Wrapper = styled.div`
  .column-container {
    margin-top: -10px;

    .column-li {
      margin: 0 0 0 -10px;
      font-size: 12px;
      padding: 1px 5px;

      &.dragging {
        background: #d1d1d161;
      }

      .anticon {
        color: #59595999;
      }
    }
  }

  .btn-container {
    text-align: right;
    margin-right: -5px;

    .ant-btn {
      font-size: 12px;
      margin-left: 10px;
    }
  }
`;

export const defaultSubmittedTicketableColumns = [
  // {
  //   label: 'Ticket Number',
  //   key: 'rfinumber',
  //   active: true,
  // },
  {
    label: 'Type',
    key: 'rfitype',
    active: true,
  },
  {
    label: 'Resolution Date',
    key: 'resolution_date',
    active: true,
  },
  {
    label: 'Revised Dateline',
    key: 'revised_dateline',
    active: true,
  },
  {
    label: 'Assigned Staff',
    key: 'action_by_id',
    active: true,
  },
  {
    label: 'Status',
    key: 'status',
    active: true,
  },
  {
    label: 'Buyer Entity',
    key: 'entity_id',
    active: true,
  },
  {
    label: 'Region',
    key: 'region',
    active: true,
  },
  {
    label: 'Company',
    key: 'company',
    active: true,
  },
  {
    label: 'Timestamp',
    key: 'created_at',
    active: true,
  },
  {
    label: 'Requestor',
    key: 'requestor',
    active: true,
  },
  {
    label: 'Deadline',
    key: 'date_needed_by',
    active: true,
  },
  {
    label: 'Request Message',
    key: 'request_msg',
    active: true,
  },
  {
    label: 'PO Number',
    key: 'po_number',
    active: true,
  },
  {
    label: 'Supplier',
    key: 'supplier_id',
    active: true,
  },
  {
    label: 'Attachments',
    key: 'attachments',
    active: true,
  },
  {
    label: 'Note',
    key: 'comment',
    active: true,
  },
];

export default SubmitTicketColumns;
